<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Clinic Doctors",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Clinic Doctors",
            items: [
               {
                  text: "Clinic",
                  href: "/clinics",
               },  
               {
                  text: "Clinic Doctors",
                  active: true,
               },                   
            ],
            listing_length: 10,
            keyword: '',
            status: '',
            from: null,
            to: null,
            total: null,
            pagination: {},
            doctors: [],
            clinic:{},
            display: {
               doctor_id: "",
               status: "",
            },
            scroll: {
               doctor_id: "",
               status: "",
            },
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchDoctors();
      },

      methods: {
         fetchDoctors(page_url = null) {

         this.getToken();
         let url = "api/admin/clinics/doctors?keyword=" + this.keyword + "&limit=" + this.listing_length + "&clinic_id=" + this.$route.params.id;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
         this.loading = true;

         this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.doctors = responseData.doctors.data;
               this.clinic = responseData.clinic;
               
               this.pagination = responseData.doctors.links;
               this.from = responseData.doctors.from;
               this.to = responseData.doctors.to;
               this.total = responseData.doctors.total;
            
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         enableName(doctor) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to enable display name?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.display.doctor_id = doctor.id;
                  this.display.status = 1;
                  this.updateDisplayStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         disableName(doctor) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to disable display name?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.display.doctor_id = doctor.id;
                  this.display.status = 2;
                  this.updateDisplayStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateDisplayStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/clinics/disable_name?doctor_id=" + this.display.doctor_id + "&display_name=" + this.display.status+ "&clinic_id=" + this.$route.params.id;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchDoctors(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
         enableScrollUp(doctor) {
            this.activate = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to enable scroll up?', {
               title: 'Confirm',
               size: 'sm',
               buttonSize: 'sm',
               okVariant: 'danger',
               okTitle: 'Yes',
               cancelTitle: 'No',
               footerClass: 'p-2',
               hideHeaderClose: false,
               centered: true
            })
            .then(value => {
               this.activate = value
               if(this.activate){
                  this.scroll.doctor_id = doctor.id;
                  this.scroll.status = 1;
                  this.updateScrollUp();
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
         disableScrollUp(doctor) {
            this.deactivate = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to disable scroll up?', {
               title: 'Confirm',
               size: 'sm',
               buttonSize: 'sm',
               okVariant: 'danger',
               okTitle: 'Yes',
               cancelTitle: 'No',
               footerClass: 'p-2',
               hideHeaderClose: false,
               centered: true
            })
            .then(value => {
               this.deactivate = value
               if(this.deactivate){
                  this.scroll.doctor_id = doctor.id;
                  this.scroll.status = 2;
                  this.updateScrollUp();
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
         updateScrollUp() {
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/clinics/update_scroll_up?doctor_id=" + this.scroll.doctor_id + "&scroll_up=" + this.scroll.status + "&clinic_id=" + this.$route.params.id;
            this.$axios
               .get(url, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchDoctors(this.active_page_url);
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-4">

                     <div class="col-md-7">
                        <h4>{{clinic.name}}</h4>
                        <h5>{{clinic.place}}</h5>
                     </div>

                     <div class="col-md-5">
                        <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">

                     

                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchDoctors()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchDoctors()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Name</th>  
                              <th>Specializations</th>
                              <th>Contact</th>
                              <th>Display Name</th>
                              <th>Scroll Up</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(doctors.length)">
                           <tr v-for="(doctor) in doctors" :key="doctor.id">
                              <td>{{doctor.name}}</td>
                              <td> <span v-for="specialization in doctor.specializations" :key="specialization.id">
                                       {{specialization.specialization}}<br>
                                    </span>
                              </td>
                              <td>
                                 {{doctor.country_code}} {{doctor.mobile}}<br>
                                 {{doctor.email}} <br>
                              </td> 
                              <td> 
                                 <span v-if="doctor.display_name==1">Yes</span>
                                 <span v-else>No</span>
                              </td>
                              <td>
                                 <span v-if="Number(doctor.scroll_up)==1">Yes</span>
                                 <span v-else>No</span>
                              </td>
                              <td>
                                 <router-link :to="{ name: 'doctors.details' , params: {id: doctor.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Doctor Details</router-link>
                                 <b-button v-if="doctor.display_name==1" variant="danger" class="btn-sm me-2 mb-2" @click="disableName(doctor)">Disable Display Name</b-button>
                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="enableName(doctor)">Enable Display Name</b-button>
                                 <b-button v-if="Number(doctor.scroll_up)==1" variant="danger" class="btn-sm me-2 mb-2" @click="disableScrollUp(doctor)">Disable Scroll Up</b-button>
                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="enableScrollUp(doctor)">Enable Scroll Up</b-button>
                                 <router-link :to="{ name: 'clinics.doctor.doctortokencalls' , params: { id: doctor.id, clinic_id: $route.params.id }}" class="btn btn-primary btn-sm me-2 mb-2">Token calls</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(doctors.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchDoctors(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&clinic_id=' + $route.params.id)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
